import type { ReactNode, Ref } from 'react';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type FilterSettingsMobileButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  ref?: Ref<HTMLButtonElement>;
};
export const FilterSettingsMobileButton = ({
  children,
  onClick,
  ref,
}: FilterSettingsMobileButtonProps) => (
  <Button ref={ref} className="flex h-[2.75rem] pr-1 sm:h-[2.25rem]" onClick={onClick}>
    <div className="mr-auto w-full overflow-hidden text-left leading-normal hyphens-auto">
      {children}
    </div>
    <span className="icon-emp-arrow-medium-down size-4" />
  </Button>
);
